import Model from "@olton/model";

globalThis.Model = Model;
